module.exports = __webpack_public_path__ + "static/fonts/Fact-CondensedMedium.3ab6158.woff2";